// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro-logo {
  width: 20%;
  max-width: 400px;
  margin: 0 auto;
  display: block;
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/paywall/paywall.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AACJ","sourcesContent":[".intro-logo {\n    width: 20%;\n    max-width: 400px;\n    margin: 0 auto;\n    display: block;\n    margin-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
